import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import FolderIcon from '@mui/icons-material/Folder';
import LogoutIcon from '@mui/icons-material/Logout';
import LockOpenIcon from '@mui/icons-material/LockOpen'; // Icono para aperturar
import LockIcon from '@mui/icons-material/Lock'; // Icono para aperturar
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'context/AuthContext';

function AccionesCell({ id_orden_detalle, numeroOrdenCabecera, status, onEdit, onDelete, onFinalize, onAperturar }) {
  const navigate = useNavigate();

  // 🔒 Roles
  const { hasRole } = useContext(AuthContext);
  const isClient = hasRole('client');

  const handleDocumentsClick = () => {
    navigate(`/ordenes/${numeroOrdenCabecera}/embarques/${id_orden_detalle}/documentos/`);
  };

  const handleTrafficClick = () => {
    navigate(`/ordenes/embarques/traficos/${id_orden_detalle}`);
  };

  // Convertir status a número para comparar correctamente (0 = aperturado, 1 = finalizado)
  const isAperturado = Number(status) === 0;
  console.log(status)
  return (
    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
      <IconButton aria-label="ver" color="warning">
        <InfoIcon />
      </IconButton>

      <IconButton aria-label="Editar" color="info" onClick={handleTrafficClick}>
        <LocalShippingIcon />
      </IconButton>

      <IconButton aria-label="Documentos" color="warning" onClick={handleDocumentsClick}>
        <FolderIcon />
      </IconButton>
    {!isClient && (
      <>
      {isAperturado ? (
        <IconButton
          aria-label="Finalizar"
          color="error"  // Botón rojo
          onClick={() => onFinalize(id_orden_detalle)}
        >
          <LogoutIcon />
        </IconButton>
      ) : (
        <IconButton
          aria-label="Aperturar"
          color="success"  // Botón verde
          onClick={() => onAperturar(id_orden_detalle)}
        >
          <LogoutIcon />
        </IconButton>
      )}

      <IconButton aria-label="Editar" color="info" onClick={onEdit}>
        <EditIcon />
      </IconButton>

      <IconButton aria-label="Eliminar" color="error" onClick={onDelete}>
        <DeleteIcon />
      </IconButton>
      </>
    )}
    </div>
  );
}

AccionesCell.propTypes = {
  id_orden_detalle: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  numeroOrdenCabecera: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onFinalize: PropTypes.func.isRequired,
  onAperturar: PropTypes.func.isRequired,
};

export default AccionesCell;
